import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
    scrollBehavior(to, _from) {
        if (!to.hash) {
            return { left: 0, top: 0, behavior: 'smooth' };
        }
        return null;
    },
    scrollBehaviorType: 'smooth',
};
